import { Injectable } from '@angular/core';
import { Tank } from '../interfaces/tank';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TankCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/settings/tanks/' ;
  }

  // Create Tank
  add(record: Tank) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single Tank Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch Tanks List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update Tank Object
  update(record: Tank) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<Tank>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Tank Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}